/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type settingsSubscription_subscription$ref: FragmentReference;
declare export opaque type settingsSubscription_subscription$fragmentType: settingsSubscription_subscription$ref;
export type settingsSubscription_subscription = {|
  +planId: ?string,
  +billingPeriod: ?number,
  +billingPeriodType: ?string,
  +currency: ?string,
  +email: ?string,
  +cardLast4: ?string,
  +cardType: ?string,
  +cardholderName: ?string,
  +expirationDate: ?string,
  +nextPaymentDateYear: ?number,
  +nextPaymentDateMonth: ?number,
  +nextPaymentDateDay: ?number,
  +nextAmountDue: ?number,
  +credit: ?number,
  +nextPartialAmount: ?number,
  +unpaid: ?number,
  +seats: ?number,
  +virtualSeats: ?number,
  +seatPrice: ?number,
  +partialPaymentLines: ?$ReadOnlyArray<?{|
    +id: string,
    +amount: ?number,
    +description: ?string,
  |}>,
  +history: ?$ReadOnlyArray<?{|
    +dateYear: ?number,
    +dateMonth: ?number,
    +dateDay: ?number,
    +amount: ?number,
    +type: ?string,
    +paid: ?boolean,
    +invoiceUrl: ?string,
  |}>,
  +coupons: ?$ReadOnlyArray<?{|
    +id: string,
    +amountOff: ?number,
    +duration: ?string,
    +durationInMonths: ?number,
    +percentOff: ?number,
  |}>,
  +$refType: settingsSubscription_subscription$ref,
|};
export type settingsSubscription_subscription$data = settingsSubscription_subscription;
export type settingsSubscription_subscription$key = {
  +$data?: settingsSubscription_subscription$data,
  +$fragmentRefs: settingsSubscription_subscription$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsSubscription_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingPeriodType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardLast4",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardholderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expirationDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextPaymentDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextPaymentDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextPaymentDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextAmountDue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextPartialAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unpaid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seats",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "virtualSeats",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seatPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PartialPaymentLine",
      "kind": "LinkedField",
      "name": "partialPaymentLines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingHistory",
      "kind": "LinkedField",
      "name": "history",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateDay",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Coupon",
      "kind": "LinkedField",
      "name": "coupons",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountOff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationInMonths",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentOff",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Subscription"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d07d3530e39c03fb0a2927620789790';

module.exports = node;
